
import React from 'react';
import './CheckBox.css';

interface ICheckbox{
    checked?: boolean;
    onChange: (checked: boolean) => void;
}

const CheckBox: React.FC<ICheckbox> = ({checked, onChange}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.checked);
    };

    return(
        <label className="custom-checkbox">
            <input type="checkbox" checked={checked} onChange={handleChange}/>
            <span className="checkbox"></span>
        </label>
    );
}

export default CheckBox;